module.exports = __webpack_public_path__ + "dbd3f7e7be989273999f1782df91158d.png";